import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Header = ({ onMenuClick, user, onLogout, title }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className="bg-white border-b border-slate-200 h-16 flex items-center justify-between px-4 lg:px-6 flex-shrink-0 w-full fixed top-0 left-0 right-0 z-[60]">
      {/* Left side */}
      <div className="flex items-center space-x-4">
        {/* Mobile menu button */}
        <button
          onClick={onMenuClick}
          className="lg:hidden p-2 rounded-md text-slate-400 hover:text-slate-500 hover:bg-slate-100"
        >
          <FontAwesomeIcon icon="bars" />
        </button>

        {/* ProposalAI Logo */}
        <div className="flex items-center space-x-3">
          <div className="h-8 w-8 bg-primary-500 rounded-lg flex items-center justify-center">
            <FontAwesomeIcon icon="robot" className="text-white text-sm" />
          </div>
          <span className="text-xl font-bold text-slate-900">Adapt2Win</span>
        </div>

        {/* Page title */}
        {title && (
          <>
            <div className="h-6 w-px bg-slate-300"></div>
            <h1 className="text-lg font-semibold text-slate-900">{title}</h1>
          </>
        )}
      </div>

      {/* Right side */}
      <div className="flex items-center space-x-4">
        {/* Notifications (placeholder) */}
        <button className="p-2 rounded-md text-slate-400 hover:text-slate-500 hover:bg-slate-100 relative">
          <FontAwesomeIcon icon="bell" />
        </button>

        {/* User dropdown - moved outside header stacking context */}
        <div className="relative z-[70]" ref={dropdownRef}>
          <button
            onClick={() => setDropdownOpen(!dropdownOpen)}
            className="flex items-center space-x-3 p-2 rounded-md hover:bg-slate-100 transition-colors duration-200"
          >
            <div className="h-8 w-8 bg-primary-100 rounded-full flex items-center justify-center">
              <FontAwesomeIcon
                icon="user"
                className="text-primary-600 text-sm"
              />
            </div>
            <div className="hidden md:block text-left">
              <p className="text-sm font-medium text-slate-900">
                {user?.username}
              </p>
              <p className="text-xs text-slate-500 capitalize">{user?.role}</p>
            </div>
            <FontAwesomeIcon
              icon={dropdownOpen ? "chevron-up" : "chevron-down"}
              className="text-slate-400 text-xs"
            />
          </button>

          {dropdownOpen && (
            <div className="absolute right-0 mt-2 w-48 bg-white border border-slate-200 rounded-lg shadow-lg z-[70]">
              <div className="p-3 border-b border-slate-200">
                <p className="text-sm font-medium text-slate-900">
                  {user?.username}
                </p>
                <p className="text-xs text-slate-500">{user?.email}</p>
              </div>

              <div className="py-1">
                <button
                  onClick={() => {
                    setDropdownOpen(false);
                    // Navigate to profile (future feature)
                  }}
                  className="w-full text-left px-3 py-2 text-sm text-slate-700 hover:bg-slate-100"
                >
                  <FontAwesomeIcon icon="user" className="mr-2 text-xs" />
                  Profile
                </button>

                <button
                  onClick={() => {
                    setDropdownOpen(false);
                    // Navigate to settings (future feature)
                  }}
                  className="w-full text-left px-3 py-2 text-sm text-slate-700 hover:bg-slate-100"
                >
                  <FontAwesomeIcon icon="cog" className="mr-2 text-xs" />
                  Settings
                </button>
              </div>

              <div className="border-t border-slate-200 py-1">
                <button
                  onClick={() => {
                    setDropdownOpen(false);
                    onLogout();
                  }}
                  className="w-full text-left px-3 py-2 text-sm text-red-600 hover:bg-red-50"
                >
                  <FontAwesomeIcon
                    icon="sign-out-alt"
                    className="mr-2 text-xs"
                  />
                  Sign Out
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
